import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Download, AlertTriangle, CheckCircle, XCircle, Clock, Users, Wrench, Shield, FileText, Car, Calendar, MapPin, DollarSign, TrendingUp, AlertCircle, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';

export const InformeVehicularPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const searchType = searchParams.get('type') || '';
  const vinValue = searchParams.get('value') || '';
  const placa = searchParams.get('placa') || 'ABC-123';
  const tipoDoc = searchParams.get('tipoDoc') || 'CC';
  const numDoc = searchParams.get('numDoc') || '1234567890';

  // Datos quemados del vehículo
  const vehicleData = {
    foto: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=800&h=500&fit=crop',
    marca: 'Toyota',
    modelo: 'Corolla Cross',
    año: 2021,
    vin: searchType === 'vin' ? vinValue : 'JTDEPRAE5LJ051234',
    placa: searchType === 'vin' ? 'ABC-123' : placa,
    combustible: 'Gasolina',
    cilindraje: '2.0L',
    transmision: 'Automática CVT',
    kilometraje: '98,450 km',
    ultimoReporte: '10 de Enero, 2025',
    color: 'Gris Plata'
  };

  const resumenEstado = [
    { icon: Users, titulo: 'Propietarios', valor: '3', color: 'text-yellow-400', bg: 'bg-yellow-500/20', badge: 'Múltiples' },
    { icon: AlertTriangle, titulo: 'Accidentes', valor: '1', color: 'text-orange-400', bg: 'bg-orange-500/20', badge: 'Leve' },
    { icon: Shield, titulo: 'Siniestros', valor: '2', color: 'text-red-400', bg: 'bg-red-500/20', badge: 'Reportados' },
    { icon: FileText, titulo: 'Multas Activas', valor: '1', color: 'text-red-400', bg: 'bg-red-500/20', badge: 'Pendiente' },
    { icon: CheckCircle, titulo: 'SOAT Vigente', valor: '15/08/25', color: 'text-green-400', bg: 'bg-green-500/20', badge: 'Al día' },
    { icon: CheckCircle, titulo: 'Tecnomecánica', valor: '10/02/26', color: 'text-green-400', bg: 'bg-green-500/20', badge: 'Al día' },
    { icon: Wrench, titulo: 'Mantenimientos', valor: '17', color: 'text-blue-400', bg: 'bg-blue-500/20', badge: 'Registrados' },
    { icon: TrendingUp, titulo: 'Kilometraje', valor: '98,450', color: 'text-purple-400', bg: 'bg-purple-500/20', badge: 'km' }
  ];

  const historial = [
    { fecha: '2025-01-10', taller: 'AutoPro Motors', servicio: 'Cambio de aceite y filtros', tipo: 'Preventivo', estado: 'Completado' },
    { fecha: '2024-10-22', taller: 'Frenos y Más', servicio: 'Mantenimiento de frenos', tipo: 'Preventivo', estado: 'Completado' },
    { fecha: '2024-07-12', taller: 'AutoPro Motors', servicio: 'Alineación y balanceo', tipo: 'Preventivo', estado: 'Completado' },
    { fecha: '2024-04-05', taller: 'Electro Auto', servicio: 'Reparación eléctrica menor', tipo: 'Correctivo', estado: 'Completado' },
    { fecha: '2023-12-16', taller: 'CarroSeguro Taller', servicio: 'Revisión por golpe leve', tipo: 'Correctivo', estado: 'Completado' },
    { fecha: '2023-12-16', taller: 'Aseguradora Sura', servicio: 'Reclamo siniestro leve', tipo: 'Seguro', estado: 'Procesado' },
    { fecha: '2023-03-08', taller: 'Baterías Total', servicio: 'Cambio de batería', tipo: 'Correctivo', estado: 'Completado' }
  ];

  const accidentes = [
    {
      tipo: 'Colisión leve',
      fecha: '16/12/2023',
      ubicacion: 'Cali, Colombia',
      aseguradora: 'Sura',
      detalles: 'Daño en parachoques delantero derecho. Reparación completa realizada.',
      gravedad: 'Leve',
      fotos: ['https://images.unsplash.com/photo-1606577924006-27d39b132ae2?w=400&h=300&fit=crop']
    }
  ];

  const siniestros = [
    { fecha: '16/12/2023', tipo: 'Golpe leve lateral', aseguradora: 'Sura', monto: '$2,500,000', estado: 'Cerrado' },
    { fecha: '05/04/2024', tipo: 'Reparación sistema eléctrico', aseguradora: 'Sura', monto: '$850,000', estado: 'Cerrado' }
  ];

  const multas = [
    { numero: '0019281', fecha: '10/09/2024', motivo: 'Exceso de velocidad', ciudad: 'Palmira', valor: '$438,000', estado: 'Pendiente' }
  ];

  const propietarios = [
    { periodo: '2020 - 2025', nombre: 'Juan Carlos Pérez', tipo: 'Particular' },
    { periodo: '2018 - 2020', nombre: 'Automotores del Valle S.A.', tipo: 'Concesionario' },
    { periodo: '2014 - 2018', nombre: 'María González', tipo: 'Particular' }
  ];

  const alertas = [
    { tipo: 'warning', titulo: 'Cambio de aceite recomendado', descripcion: 'Próximo cambio estimado en 2,000 km', icon: AlertCircle },
    { tipo: 'info', titulo: 'Revisión de frenos', descripcion: 'Recomendado en los próximos 5,000 km', icon: Clock },
    { tipo: 'warning', titulo: 'Desgaste de llantas', descripcion: 'Considerar revisión según historial', icon: AlertTriangle }
  ];

  const handleDownloadPDF = () => {
    toast.success('Preparando descarga del informe en PDF...');
  };

  return (
    <div className="min-h-screen pt-20 pb-20 bg-gradient-to-b from-slate-900 via-purple-900/10 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back button */}
        <Button 
          onClick={() => navigate('/reportes')}
          variant="outline"
          className="mb-6 border-purple-500/30 text-purple-400 hover:bg-purple-500/10"
        >
          ← Volver a búsqueda
        </Button>

        {/* Header del vehículo */}
        <Card className="bg-white/5 backdrop-blur-sm border-purple-500/20 p-8 mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-1">
              <img 
                src={vehicleData.foto} 
                alt="Vehículo" 
                className="w-full h-64 object-cover rounded-xl"
              />
            </div>
            <div className="lg:col-span-2">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h1 className="text-4xl font-bold text-white mb-2">
                    {vehicleData.marca} {vehicleData.modelo}
                  </h1>
                  <p className="text-gray-400 text-xl">{vehicleData.año}</p>
                </div>
                <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-2 rounded-xl font-bold">
                  VERIFICADO
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-6">
                <div className="bg-white/5 rounded-lg p-4">
                  <p className="text-gray-400 text-sm mb-1">VIN</p>
                  <p className="text-white font-mono text-sm">{vehicleData.vin}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4">
                  <p className="text-gray-400 text-sm mb-1">Placa</p>
                  <p className="text-white font-bold text-lg">{vehicleData.placa}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4">
                  <p className="text-gray-400 text-sm mb-1">Combustible</p>
                  <p className="text-white">{vehicleData.combustible}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4">
                  <p className="text-gray-400 text-sm mb-1">Cilindraje</p>
                  <p className="text-white">{vehicleData.cilindraje}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4">
                  <p className="text-gray-400 text-sm mb-1">Transmisión</p>
                  <p className="text-white">{vehicleData.transmision}</p>
                </div>
                <div className="bg-white/5 rounded-lg p-4">
                  <p className="text-gray-400 text-sm mb-1">Color</p>
                  <p className="text-white">{vehicleData.color}</p>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-between bg-purple-500/10 rounded-lg p-4">
                <div>
                  <p className="text-gray-400 text-sm">Kilometraje Actual</p>
                  <p className="text-white text-2xl font-bold">{vehicleData.kilometraje}</p>
                </div>
                <div className="text-right">
                  <p className="text-gray-400 text-sm">Último Reporte</p>
                  <p className="text-white">{vehicleData.ultimoReporte}</p>
                </div>
              </div>
            </div>
          </div>
        </Card>

        {/* Resumen del estado */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-6">Resumen General del Estado</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {resumenEstado.map((item, index) => {
              const Icon = item.icon;
              return (
                <Card key={index} className={`${item.bg} backdrop-blur-sm border-purple-500/20 p-6 hover:border-purple-500/40 transition-all`}>
                  <div className="flex items-start justify-between mb-3">
                    <Icon className={item.color} size={28} />
                    <span className={`text-xs px-2 py-1 rounded-full ${item.bg} ${item.color} font-semibold`}>
                      {item.badge}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm mb-1">{item.titulo}</p>
                  <p className={`${item.color} text-2xl font-bold`}>{item.valor}</p>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Historial de Mantenimiento */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-6">Historial de Mantenimiento</h2>
          <Card className="bg-white/5 backdrop-blur-sm border-purple-500/20 p-6">
            <div className="space-y-4">
              {historial.map((item, index) => (
                <div key={index} className="flex items-start space-x-4 pb-4 border-b border-purple-500/20 last:border-0">
                  <div className="flex-shrink-0">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
                      item.tipo === 'Preventivo' ? 'bg-green-500/20' : 
                      item.tipo === 'Correctivo' ? 'bg-orange-500/20' : 'bg-blue-500/20'
                    }`}>
                      <Wrench className={
                        item.tipo === 'Preventivo' ? 'text-green-400' : 
                        item.tipo === 'Correctivo' ? 'text-orange-400' : 'text-blue-400'
                      } size={20} />
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between">
                      <div>
                        <h3 className="text-white font-semibold mb-1">{item.servicio}</h3>
                        <p className="text-gray-400 text-sm">{item.taller}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-gray-400 text-sm">{item.fecha}</p>
                        <span className={`text-xs px-2 py-1 rounded-full ${
                          item.tipo === 'Preventivo' ? 'bg-green-500/20 text-green-400' : 
                          item.tipo === 'Correctivo' ? 'bg-orange-500/20 text-orange-400' : 'bg-blue-500/20 text-blue-400'
                        }`}>
                          {item.tipo}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Accidentes y Siniestros */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {/* Accidentes */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-6">Accidentes Reportados</h2>
            {accidentes.map((accidente, index) => (
              <Card key={index} className="bg-white/5 backdrop-blur-sm border-orange-500/20 p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 rounded-full bg-orange-500/20 flex items-center justify-center">
                      <AlertTriangle className="text-orange-400" size={24} />
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-lg">{accidente.tipo}</h3>
                      <p className="text-gray-400 text-sm">{accidente.fecha}</p>
                    </div>
                  </div>
                  <span className="bg-orange-500/20 text-orange-400 px-3 py-1 rounded-full text-sm font-semibold">
                    {accidente.gravedad}
                  </span>
                </div>
                <div className="space-y-2 mb-4">
                  <div className="flex items-center space-x-2 text-gray-300">
                    <MapPin size={16} className="text-gray-400" />
                    <span className="text-sm">{accidente.ubicacion}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-300">
                    <Shield size={16} className="text-gray-400" />
                    <span className="text-sm">Aseguradora: {accidente.aseguradora}</span>
                  </div>
                </div>
                <p className="text-gray-400 text-sm mb-4">{accidente.detalles}</p>
                <div className="grid grid-cols-2 gap-2">
                  {accidente.fotos.map((foto, idx) => (
                    <img key={idx} src={foto} alt="Daño" className="w-full h-32 object-cover rounded-lg" />
                  ))}
                </div>
              </Card>
            ))}
          </div>

          {/* Siniestros */}
          <div>
            <h2 className="text-3xl font-bold text-white mb-6">Reclamaciones de Seguro</h2>
            <div className="space-y-4">
              {siniestros.map((siniestro, index) => (
                <Card key={index} className="bg-white/5 backdrop-blur-sm border-red-500/20 p-6">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center">
                        <Shield className="text-red-400" size={20} />
                      </div>
                      <div>
                        <h3 className="text-white font-semibold">{siniestro.tipo}</h3>
                        <p className="text-gray-400 text-sm">{siniestro.fecha}</p>
                      </div>
                    </div>
                    <span className="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-xs font-semibold">
                      {siniestro.estado}
                    </span>
                  </div>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-purple-500/20">
                    <span className="text-gray-400 text-sm">Aseguradora: {siniestro.aseguradora}</span>
                    <span className="text-white font-bold">{siniestro.monto}</span>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* Multas */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-6">Multas y Comparendos</h2>
          <Card className="bg-white/5 backdrop-blur-sm border-red-500/20 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-red-500/10">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-white">Comparendo</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-white">Fecha</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-white">Motivo</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-white">Ciudad</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-white">Valor</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-white">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {multas.map((multa, index) => (
                    <tr key={index} className="border-t border-purple-500/20">
                      <td className="px-6 py-4 text-white font-mono">#{multa.numero}</td>
                      <td className="px-6 py-4 text-gray-300">{multa.fecha}</td>
                      <td className="px-6 py-4 text-gray-300">{multa.motivo}</td>
                      <td className="px-6 py-4 text-gray-300">{multa.ciudad}</td>
                      <td className="px-6 py-4 text-white font-bold">{multa.valor}</td>
                      <td className="px-6 py-4">
                        <span className="bg-red-500/20 text-red-400 px-3 py-1 rounded-full text-sm font-semibold">
                          {multa.estado}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>

        {/* Propietarios */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-6">Historial de Propietarios</h2>
          <Card className="bg-white/5 backdrop-blur-sm border-purple-500/20 p-6">
            <div className="space-y-4">
              {propietarios.map((prop, index) => (
                <div key={index} className="flex items-center space-x-4 pb-4 border-b border-purple-500/20 last:border-0">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <Users className="text-blue-400" size={24} />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-white font-semibold">{prop.nombre}</h3>
                    <p className="text-gray-400 text-sm">{prop.tipo}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-white font-mono">{prop.periodo}</p>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Alertas y Recomendaciones */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-white mb-6">Alertas y Recomendaciones</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {alertas.map((alerta, index) => {
              const Icon = alerta.icon;
              return (
                <Card key={index} className={`backdrop-blur-sm border-purple-500/20 p-6 ${
                  alerta.tipo === 'warning' ? 'bg-yellow-500/10' : 'bg-blue-500/10'
                }`}>
                  <Icon className={alerta.tipo === 'warning' ? 'text-yellow-400' : 'text-blue-400'} size={32} />
                  <h3 className="text-white font-semibold mt-3 mb-2">{alerta.titulo}</h3>
                  <p className="text-gray-400 text-sm">{alerta.descripcion}</p>
                </Card>
              );
            })}
          </div>
        </div>

        {/* CTA Final */}
        <Card className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 border-purple-500/30 backdrop-blur-sm p-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Informe Completo Verificado</h2>
          <p className="text-gray-300 text-lg mb-8">
            Toda la información del vehículo en un documento profesional
          </p>
          <Button 
            onClick={handleDownloadPDF}
            size="lg"
            className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-12 py-6 text-lg rounded-xl shadow-lg"
          >
            <Download className="mr-2" size={24} />
            Descargar Informe PDF
          </Button>
          <p className="text-gray-400 text-sm mt-4">
            Informe generado por VERSO NUBE • Verificado y actualizado
          </p>
        </Card>
      </div>
    </div>
  );
};
